export default () => {
    const selectShippingAdresses = document.getElementById('thmaf_shipping_alt');

    if(selectShippingAdresses) {
        const selectOptions = selectShippingAdresses.options;

        Array.from(selectOptions).forEach((adressValue, i) => {
            let inputWrapper = document.createElement('div');
            inputWrapper.classList.add('inputWrapper')
            let labelValue = document.createElement('label');
            labelValue.innerHTML = adressValue.innerHTML;
            let inputValue = document.createElement('input');
            inputValue.type = "radio";
            inputValue.name = 'adressesRadioSelection';
            inputValue.value = adressValue.value;
            inputValue.adressValue = i;
    
            const selectShippingAdressesParagraph = document.getElementById('thmaf_shipping_alt_field');

            selectShippingAdressesParagraph.appendChild(inputWrapper);
    
            inputWrapper.appendChild(inputValue);
            inputWrapper.appendChild(labelValue);

            if(inputValue.value == selectOptions[selectShippingAdresses.selectedIndex].value){
                inputWrapper.classList.add('is-active');
            }  
    
            if(labelValue.innerHTML == 'Add New Address'){
                inputWrapper.classList.add('display-none');
            }
    
            inputWrapper.addEventListener('click', () => { 
                selectOptions[selectShippingAdresses.selectedIndex].value = inputValue.value;
                selectOptions[selectShippingAdresses.selectedIndex].text = labelValue.innerHTML;
                 
                const inputWrappers = document.querySelectorAll('.inputWrapper');
                inputWrappers.forEach( el => {
                    el.classList.remove('is-active');
                });
               
                if(inputValue.value == selectOptions[selectShippingAdresses.selectedIndex].value){
                    inputWrapper.classList.add('is-active');
                } 
    
                triggerChange(selectShippingAdresses);
                 
            })  
    
        });

        function triggerChange(element) {
            let changeEvent = new Event('change');
            element.dispatchEvent(changeEvent);
        }

    }

 
    

};
 